import React, { useState, useEffect, useRef, useCallback } from "react";
import MapDashboard from "./MapDashBoard/MapDashboard";
import MapDashboardOld from "./MapDashBoardOld/MapDashboardOld";
import { useGlobalContext } from "../../GlobalContext";
import { AnimatePresence, motion } from "framer-motion";
import useShop from "../../Sevices/useShop";
import useTasks from "../../Sevices/useTasks";
import useDriver from "../../Sevices/Driver Api/useDriver";
import useDashboard from "../../Sevices/useDashboard";
import useDriverTeams from "../../Sevices/Driver Api/useDriverTeams";
import useNotification from "../../Sevices/useNotification";
import Header from "./Header";
import AddTaskModal from "./AddTaskModal";
import useDriverConfig from "../../Sevices/Driver Api/useDriverConfig";

export default function DashboardContainer() {
  const {
    baseurl,
    token,
    accessToken,
    setIsUnauthorised,
    socketData,
    AdminId,
    isAddTaskOpen, setIsAddTaskOpen, shops
  } = useGlobalContext();

  const { fetchShops } = useShop();

  const { fetchTasks, fetchTaskLogs, changeTaskStatus } = useTasks();

const {
  handleToggle,
  ShowToggleStatus,
  SyncWithAnlook,
  fetchCustomerInstructions,
  isChecked,
  loading,
  instructionTaskIds,

  dashboardTabCounts,
  dashboardTabsLoading,
  fetchDashboardTabsCount,
} = useDashboard();

 const {
  fetchDrivers,
  AssignTaskToDriver,
  editDriverApi,
  updateDriverDutyApi,
  toggleDutyStatus,
} = useDriver();
const {
  fetchDriverConfigByCode,
  fetchSingleDriverConfig,
  saveSingleDriverConfig,
  deleteDriverConfig,
} = useDriverConfig();

  const { teams, fetchDriverTeams } = useDriverTeams();
const { sendNotification } = useNotification();

const [tasks, setTasks] = useState([]);
  const [agents, setAgents] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isAutoAssignChecked, setIsAutoAssignChecked] = useState(true);
  const [autoAssignLoading, setAutoAssignLoading] = useState(false);
  const { showOld, setShowOld } = useGlobalContext();
  const [selectedTeam, setSelectedTeam] = useState("All Team");

  const todayStr = new Date().toISOString().split("T")[0];

const [fromDate, setFromDate] = useState(todayStr);
const [toDate, setToDate] = useState(todayStr);

const [selectedDashboardTaskTab, setSelectedDashboardTaskTab] =
  useState("all");

const [taskPageInfo, setTaskPageInfo] = useState({
  nextToken: "",
  previousToken: "",
  pageSize: 50,
  totalCount: 0,
  pageNumber: 1,
});

const [taskLoadingMore, setTaskLoadingMore] = useState(false);

const taskFirstPageLoadingRef = useRef(false);
const taskLoadMoreLockRef = useRef(false);

const getStatusesForTaskTab = useCallback((tab) => {
  const statusMap = {
    all: ["all"],
    unassigned: ["unassigned"],
    assigned: ["assigned", "started", "inprogress"],
    acknowledged: ["acknowledged"],
    arrived: ["arrived"],
    "food is ready": ["food is ready"],
    "picked up": ["picked up"],
    completed: ["successful"],
    cancelled: ["cancelled", "failed", "declined"],
  };

  return statusMap[tab] || ["all"];
}, []);

const loadDashboardTaskPage = useCallback(
  async ({ mode = "replace" } = {}) => {
    if (!fromDate || !toDate) return;

    if (mode === "replace" && taskFirstPageLoadingRef.current) return;

    taskFirstPageLoadingRef.current = true;
    setIsLoading(true);

    try {
      await fetchTasks(fromDate, toDate, setTasks, {
        pageSize: taskPageInfo.pageSize || 50,
        status: getStatusesForTaskTab(selectedDashboardTaskTab),
        nextToken: "",
        previousToken: "",
        setPageInfo: setTaskPageInfo,
        mode,
      });
    } finally {
      setIsLoading(false);
      taskFirstPageLoadingRef.current = false;
    }
  },
  [
    fromDate,
    toDate,
    fetchTasks,
    taskPageInfo.pageSize,
    selectedDashboardTaskTab,
    getStatusesForTaskTab,
  ]
);

const loadMoreDashboardTasks = useCallback(async () => {
  if (!fromDate || !toDate) return;
  if (!taskPageInfo.nextToken) return;
  if (taskLoadingMore) return;
  if (taskLoadMoreLockRef.current) return;

  taskLoadMoreLockRef.current = true;
  setTaskLoadingMore(true);

  try {
    await fetchTasks(fromDate, toDate, setTasks, {
      pageSize: taskPageInfo.pageSize || 50,
      status: getStatusesForTaskTab(selectedDashboardTaskTab),
      nextToken: taskPageInfo.nextToken,
      previousToken: "",
      setPageInfo: setTaskPageInfo,
      mode: "append",
    });
  } finally {
    setTaskLoadingMore(false);
    taskLoadMoreLockRef.current = false;
  }
}, [
  fromDate,
  toDate,
  fetchTasks,
  taskPageInfo.nextToken,
  taskPageInfo.pageSize,
  taskLoadingMore,
  selectedDashboardTaskTab,
  getStatusesForTaskTab,
]);

const fetchTaskLogsForDashboard = useCallback(
  async (taskId) => {
    return await fetchTaskLogs(taskId, fromDate, toDate);
  },
  [fetchTaskLogs, fromDate, toDate]
);

const handleChangeStatus = useCallback(
  async (taskId, newStatus, driverId) => {
    const task = {
      pk_task_id: taskId,
      driver_id: driverId,
    };

    await changeTaskStatus(task, newStatus, async () => {
      await loadDashboardTaskPage({ mode: "replace" });
      await fetchDashboardTabsCount(fromDate, toDate);
    });

    return true;
  },
  [
    changeTaskStatus,
    loadDashboardTaskPage,
    fetchDashboardTabsCount,
    fromDate,
    toDate,
  ]
);

useEffect(() => {
  if (fromDate && toDate) {
    loadDashboardTaskPage({ mode: "replace" });
    fetchDashboardTabsCount(fromDate, toDate);
  }
}, [
  fromDate,
  toDate,
  selectedDashboardTaskTab,
  loadDashboardTaskPage,
  fetchDashboardTabsCount,
]);


  useEffect(() => {
    console.log("AdminId:", AdminId);

    if (!AdminId) return;

    const loadInitialData = async () => {
      console.log("Calling fetchShops...");

      await fetchShops();

      await fetchDriverTeams();

      const driverList = await fetchDrivers(true);

      if (Array.isArray(driverList)) {
        setAgents(driverList);
      }
    };

    loadInitialData();
  }, [AdminId]);

  useEffect(() => {
    console.log("Updated shops:", shops);
  }, [shops]);

  const instructionRef = useRef(false);

  useEffect(() => {
    if (!AdminId || !fromDate || !toDate) return;
    if (instructionRef.current) return;

    instructionRef.current = true;

    fetchCustomerInstructions(fromDate, toDate);
}, [AdminId, fromDate, toDate, fetchCustomerInstructions]);

  useEffect(() => {
    if (!socketData) return;

    const msg = socketData?.Message || "";
    console.log(" SOCKET EVENT:", msg);

    //  CASE 1: TASK STATUS CHANGE
    if (
      msg.includes("Task Status Changed") ||
      msg.includes("Task Assigned") ||
      msg.includes("Task Updated")
    ) {
      // console.log(" Auto refreshing TASKS due to WebSocket...");

      if (fromDate && toDate) {
        loadDashboardTaskPage({ mode: "replace" });
fetchDashboardTabsCount(fromDate, toDate);
      }
    }

    // CASE 2: CUSTOMER INSTRUCTION UPDATED
    if (msg.includes("customer instruction updated")) {
      fetchCustomerInstructions(fromDate, toDate);
    }
  }, [socketData]);

const commonProps = {
  tasks,
  agents,
  loading,
  isLoading,
  fromDate,
  toDate,
  shops,

  isAutoAssignChecked,
  autoAssignLoading,

  teams,
  selectedTeam,
  setSelectedTeam,

  setFromDate,
  setToDate,

  fetchTasks,
  fetchDrivers,
editDriverApi,
toggleDutyStatus,
updateDriverDutyApi,
fetchDriverConfigByCode,
fetchSingleDriverConfig,
saveSingleDriverConfig,
deleteDriverConfig,
  SyncWithAnlook,
  AssignTaskToDriver,

  handleToggle,
  ShowToggleStatus,
  isChecked,

  fetchTaskLogs: fetchTaskLogsForDashboard,
  handleChangeStatus,
  sendNotification,

  baseurl,
  token,
  accessToken,
  setIsUnauthorised,

  showOld,
  setShowOld,

  isAddTaskOpen,
  setIsAddTaskOpen,

  instructionTaskIds,
  fetchCustomerInstructions,

  // dashboard tab count logic
  dashboardTabCounts,
  dashboardTabsLoading,
  fetchDashboardTabsCount,

  // parent controlled tab
  selectedDashboardTaskTab,
  setSelectedDashboardTaskTab,

  // pagination
  taskPageInfo,
  loadDashboardTaskPage,
  loadMoreDashboardTasks,
  taskLoadingMore,
};

  const direction = showOld ? 1 : -1;

  const slideVariants = {
    enter: (dir) => ({
      x: `${dir * 100}%`,
      opacity: 1,
      position: "absolute",
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
    }),
    center: {
      x: "0%",
      opacity: 1,
      position: "absolute",
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
    },
    exit: (dir) => ({
      x: `${-dir * 100}%`,
      opacity: 1,
      position: "absolute",
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
    }),
  };

  return (
    <div className="h-full relative flex-1 overflow-visible">
      <AnimatePresence custom={direction}>
        <motion.div
          key={showOld ? "old" : "new"}
          custom={direction}
          variants={slideVariants}
          initial="enter"
          animate="center"
          exit="exit"
          transition={{
            type: "spring",
            stiffness: 320,
            damping: 32,
            mass: 0.8,
          }}
          className="h-full"
        >
          {showOld ? (
            <MapDashboardOld {...commonProps} />
          ) : (
            <MapDashboard
              {...commonProps}
              onAddTaskClick={() => setIsAddTaskOpen(true)}
            />
          )}
          {/* <Header
            onAddTaskClick={() => setIsAddTaskOpen(true)}
            showOld={showOld}
            setShowOld={setShowOld}
          /> */}

          <AddTaskModal
            isOpen={isAddTaskOpen}
            onClose={() => setIsAddTaskOpen(false)}
            shops={shops}
          />
        </motion.div>
      </AnimatePresence>
    </div>
  );
}
